import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Inject, Injector, OnInit } from '@angular/core';
import { BookingService } from '../../services/booking.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FacilityService } from 'src/app/core/services/facility.service';
import { LaasOption } from 'src/app/core/models/laas-option';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { CodeConverter } from 'server/entity/code-converter';

@Component({
  selector: 'laas-dhl-edit',
  templateUrl: './dhl-edit.component.html',
  styleUrls: ['./dhl-edit.component.scss']
})
export class DhlEditComponent extends SessionBaseComponent implements OnInit {
  DHLInfo: any;
  bookingNo: string;
  facility: string;
  bookingForwarder: string;
  editForm: FormGroup;
  updateParams: any;
  coOrgIdDesc?: string;
  typCodeOptions: LaasOption[] = [];
  timeDefiniteOptions: LaasOption[] = [];
  isPaperless: boolean;
  displayHsCodeStrs: string[] = [];
  isShowHsCodeModificationModal: boolean;

  constructor(
    injector: Injector,
    private bookingService: BookingService,
    private facilityService: FacilityService,
    private formBuilder: FormBuilder,
    private commonDataService: CommonDataService
  ) {
    super(injector);
    this.bookingNo = "";
    this.facility = "";
    this.bookingForwarder = "";
    this.updateParams = {};

    this.editForm = this.formBuilder.group({
      recipientPersonName:[''],
      recipientPhoneNumber:[''],
      recipientEmailAddress:[''],
      recipientCity:[''],
      recipientPostalCode:[''],
      currency:[''],
      payType:[''],
      billingAccountId:[''],
      remark:[''],
      deliveryOrder:[[]],
      description:[''],
      customsValue:[''],
      shipperPersonName:[''],
      dutyAndTaxPayerAccountId: '',
      toTypeCode: '',
      toTypeNumber: '',
      fromTypeCode: '',
      fromTypeNumber: '',
      pltFlag: '',
      isNoKj3: '',
      dhlTimeDefiniteOption: '',
    });

    this.isPaperless = false;
    this.isShowHsCodeModificationModal = false;
  }

  /**
   * 申報幣別是否處於未判定狀態。
   * Whether the declared currency is left undetermined.
   *
   * 自動解析判不出幣別時快遞資訊以空值落庫，須由人工於本畫面指定；不顯著標示的話，
   * 現場要到送出提單被攔下才會發現。快遞資訊載入前不判定，避免提示在畫面初始時閃現。
   */
  get isCurrencyUndetermined(): boolean {
    return this.DHLInfo != null && isNullOrEmpty(this.updateParams?.currency);
  }

  /**
   * 幣別未能收斂時，各出貨單與其解析所得的幣別，逐筆以「出貨單號 幣別」列出。
   * Each delivery order with its resolved currency, listed when the currencies failed to converge.
   *
   * 現場據此判斷該指定哪個幣別；全數無解析結果時沒有原因可說明，回空字串。
   */
  get currencyCandidatesText(): string {
    const candidates: { doNo: string; currency: string }[] = this.DHLInfo?.currencyCandidates ?? [];
    return candidates.map(candidate => `${candidate.doNo} ${candidate.currency}`).join(', ');
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.facility = this.routeStateService.getCurrent().data.facility;
    this.bookingNo = this.routeStateService.getCurrent().data.bookingNo;
    this.bookingForwarder = this.routeStateService.getCurrent().data.bookingForwarder;


    this.bookingService.getDHLInfo(this.facility, this.bookingNo).subscribe({
      next: result => {
        this.DHLInfo = result;
        console.log(this.DHLInfo);

        //UI
        this.updateParams.recipientPersonName = this.DHLInfo?.recipientPersonName;
        this.updateParams.recipientPhoneNumber = this.DHLInfo?.recipientPhoneNumber;
        this.updateParams.recipientEmailAddress = this.DHLInfo?.recipientEmailAddress;
        this.updateParams.recipientCity = this.DHLInfo?.recipientCity;
        this.updateParams.recipientPostalCode = this.DHLInfo?.recipientPostalCode;
        this.updateParams.currency = this.DHLInfo?.currency;
        this.updateParams.payType = this.DHLInfo?.payType;
        this.updateParams.billingAccountId = this.DHLInfo?.billingAccountId;
        this.updateParams.remark = this.DHLInfo?.remark;
        this.updateParams.deliveryOrder = this.DHLInfo?.deliveryOrder;
        this.updateParams.description = this.DHLInfo?.description;
        this.updateParams.customsValue = this.DHLInfo?.customsValue;
        this.updateParams.totalGrosswgt = this.DHLInfo?.totalGrosswgt;
        this.updateParams.totalCaseCnt = this.DHLInfo?.totalCaseCnt;
        this.updateParams.shipperPersonName = this.DHLInfo?.shipperPersonName;
        this.updateParams.dutyAndTaxPayerAccountId = this.DHLInfo?.dutyAndTaxPayerAccountId;
        this.updateParams.toTypeCode = this.DHLInfo?.toTypeCode;
        this.updateParams.toTypeNumber = this.DHLInfo?.toTypeNumber;
        this.updateParams.fromTypeCode = this.DHLInfo?.fromTypeCode;
        this.updateParams.fromTypeNumber = this.DHLInfo?.fromTypeNumber;

        //fixed
        this.updateParams.facility = this.facility;
        this.updateParams.bookingNo = this.bookingNo;
        this.updateParams.bookingForwarder = this.bookingForwarder;
        this.updateParams.shipperAccountId = this.DHLInfo?.shipperAccountId;
        this.updateParams.recipientCountryCode = this.DHLInfo?.recipientCountryCode;
        this.updateParams.shipTerm = this.DHLInfo?.shipTerm;
        this.updateParams.coOrgId = this.DHLInfo?.coOrgId;
        this.updateParams.isNoKj3 = this.DHLInfo?.isNoKj3;

        // if (isNullOrEmpty(this.DHLInfo?.toTypeCode)) {
        //   this.updateParams.toTypeCode = 'VAT'
        //   this.editForm.controls.toTypeCode.setValue('VAT');
        // }

        // if (isNullOrEmpty(this.DHLInfo?.fromTypeCode)) {
        //   this.updateParams.fromTypeCode = 'VAT'
        //   this.editForm.controls.fromTypeCode.setValue('VAT');
        // }

        this.updateParams.pltFlag = (isNullOrEmpty(this.DHLInfo?.pltFlag) || this.DHLInfo?.pltFlag == 'N') ? 'N' : 'Y';
        this.isPaperless = this.updateParams.pltFlag == 'Y' ? true : false;

        this.updateParams.dhlTimeDefiniteOption = isNullOrEmpty(this.DHLInfo?.dhlTimeDefiniteOption) ? 'P' : this.DHLInfo?.dhlTimeDefiniteOption;
        console.log(this.updateParams.toTypeCode);
        console.log(this.updateParams.fromTypeCode);

        if(!isNullOrEmpty(this.DHLInfo?.coOrgId)){
          this.facilityService.getLetterOrgOptions('ALL', '').subscribe({
            next: (options: any[]) => {
              if(options != null && options.length > 0){
                let opt = options.filter((option:any) => option.legalEntityOUCode == this.DHLInfo?.coOrgId);
                if(opt != null && opt.length > 0){
                  this.coOrgIdDesc = opt[0].legalEntityOUCode + '-' + opt[0].legalEntityOUName;
                }
              }
            }
          });
        }

        this.getDHLInvoiceSkuDescriptionOptions();
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "DHLTypeCode").subscribe({
      next: (options: CodeConverter[]) => {
        this.typCodeOptions = options.map(x => ({label: `${x.codeKey ?? ""} - ${x.codeDesc ?? ""}` , value:x.codeKey ?? ""}));
        if (this.laasSetting.language == 'en-us') {
          this.typCodeOptions.unshift({
            label: 'Please select',
            value: ''
          });
        } else {
          this.typCodeOptions.unshift({
            label: '請選擇',
            value: ''
          });
        }

      }

    });

    this.commonDataService
      .getCodeConverter(this.laasSetting.language, 'DropdownList', 'TimeDefiniteOptions')
      .subscribe({
        next: (result) => {
          this.timeDefiniteOptions = [...result].map((x: any) => {
            return {
              label: `${x.codeKey}-${x.codeDesc}`,
              value: x.codeKey,
            };
          });
        },
      });
  }

  saveBtn(event: any): void{
    this.updateParams.userId = this.userProfile.loginAccount;
    this.updateParams.pltFlag = this.isPaperless ? 'Y' : 'N';
    if (isNullOrEmpty(this.updateParams.dhlTimeDefiniteOption)) {
      this.updateParams.dhlTimeDefiniteOption = 'P';
    }
    this.updateParams.description = this.convertDHLInvoiceSkuDescriptionToDHLInfoDescription();


    if (isNullOrEmpty(this.updateParams.toTypeCode)) {
      this.updateParams.toTypeCode = null;
    }
    if (isNullOrEmpty(this.updateParams.fromTypeCode)) {
      this.updateParams.fromTypeCode = null;
    }

    this.bookingService.saveDHLInfo(this.updateParams).subscribe({
      next: result => {
        this.toastService.info("更新成功")
        this.routeStateService.navigateTo("/TransportOperation/BookingSearch", {bookingNoList:[this.bookingNo], errMsgs:[]})
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  closeWindow(event: any): void{
    window.close();
  }

  getDHLInvoiceSkuDescriptionOptions(): void {
    const request = {
      bookingNo: this.updateParams.bookingNo
    };

    this.bookingService.checkNoKJ3Condition(this.facility, this.bookingNo).subscribe({
      next: (result: any) => {
        this.bookingService
          .getDHLInvoiceSkuDescriptionOptions(request)
          .subscribe({
            next: (options: any[]) => {
              this.displayHsCodeStrs = options.map((x: any) => {
                return `${x.skuDescription} : ${x.hsCode}`;
              });

              if (!isNullOrEmpty(result.annotationContent)) {
                this.displayHsCodeStrs.unshift(result.annotationContent);
              }
            },
          });
      },
    });

  }

  toogleBtnClick(event: any): void {
    this.isShowHsCodeModificationModal = true;
  }

  closeDialog(event: any): void {
    this.isShowHsCodeModificationModal = false;
    this.getDHLInvoiceSkuDescriptionOptions();
  }

  convertDHLInvoiceSkuDescriptionToDHLInfoDescription(): string {
    let dhlInfoDescription: string = this.displayHsCodeStrs
      .filter(strObj => strObj !== "NO KJ3/")
      .map((strObj: string) => {

        let skuDescription = strObj.split(":")[0].trim();
        return skuDescription;
      }).join(",");
    return dhlInfoDescription;
  }

  onIsNoKj3Change($event: any) {
    if ($event) {
      this.displayHsCodeStrs = [
        "NO KJ3/",
        ...this.displayHsCodeStrs.filter(strObj => strObj !== "NO KJ3/")
      ];
    } else {
      this.displayHsCodeStrs = this.displayHsCodeStrs.filter(strObj => strObj !== "NO KJ3/")
    }
  }
}
